import { AbstractRequestClass, DetailRequestModel } from './abstract-request.class';
import { TenantMappingRequest } from './abstract-request.constants';
import { DataObject } from '../../../../../../models/data-object.models';

export class TenantRequestClass extends AbstractRequestClass {
  public getMultiEndPoints(): DetailRequestModel[] | null {
    return null;
  }
  public getMappingRequest(): DataObject {
    return TenantMappingRequest;
  }
}
